export const VisibleTo = {
  EVERYONE: 0,
  SUBSCRIBER: 1,
  PAID_SUBSCRIBER: 2,
};
